export const LEGEND_ROLE = 'legend';
